import React from 'react';
import { Navigate } from 'react-router-dom';

// Platform girişi ana login üzerinden yapılır: Firma = platform
const PlatformLogin = () => <Navigate to="/login" replace />;

export default PlatformLogin;
